import React from 'react'
import gql from 'graphql-tag'
import {Mutation} from 'react-apollo'
import AssetsUploadQueue from 'components/shared/AssetsUploadQueue'
import {getInputAssetsQuery} from './'

const createInputAssetsMutation = gql`
  mutation CreateInputAssets($input: CreateInputAssetsInput!) {
    CreateInputAssets(input: $input) {
      product {
        id
      }
    }
  }
`

const UploadAssets = ({product}) => {
  return (
    <Mutation
      mutation={createInputAssetsMutation}
      refetchQueries={[{
        query: getInputAssetsQuery,
        variables: {productId: product.id},
      }]}
    >
      {(createInputAssets) => (
        <div className="upload-assets">
          <AssetsUploadQueue
            submitAsset={(asset) => {
              return createInputAssets({
                variables: {
                  input: {
                    productId: product.id,
                    assets: JSON.stringify([asset]),
                  }
                }
              })
            }}
          />
        </div>
      )}
    </Mutation>
  )
}

export default UploadAssets
